module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', {
    attrs: {
      "type": "flex",
      "justify": "center"
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 10,
      "lg": 8
    }
  }, [_c('el-form', {
    attrs: {
      "label-position": "top",
      "label-width": "100px"
    }
  }, [_c('h1', [_vm._v("Register")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "First name:"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Your first name",
      "type": "text",
      "disabled": _vm.app.isLoading
    },
    on: {
      "input": function($event) {
        _vm.$v.credentials.first_name.$touch()
      }
    },
    model: {
      value: (_vm.credentials.first_name),
      callback: function($$v) {
        _vm.credentials.first_name = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "credentials.first_name"
    }
  }), _vm._v(" "), (_vm.$v.credentials.first_name.$error) ? _c('span', [(!_vm.$v.credentials.first_name.required) ? _c('span', {
    staticClass: "el-form-item__error"
  }, [_vm._v("Field is required.")]) : _vm._e(), _vm._v(" "), (!_vm.$v.credentials.first_name.minLength) ? _c('span', {
    staticClass: "el-form-item__error"
  }, [_vm._v("First Name must have at least " + _vm._s(_vm.$v.credentials.first_name.$params.minLength.min) + " letters.")]) : _vm._e()]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Last name:"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Your last name",
      "type": "text",
      "disabled": _vm.app.isLoading
    },
    on: {
      "input": function($event) {
        _vm.$v.credentials.last_name.$touch()
      }
    },
    model: {
      value: (_vm.credentials.last_name),
      callback: function($$v) {
        _vm.credentials.last_name = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "credentials.last_name"
    }
  }), _vm._v(" "), (_vm.$v.credentials.last_name.$error) ? _c('span', [(!_vm.$v.credentials.last_name.required) ? _c('span', {
    staticClass: "el-form-item__error"
  }, [_vm._v("Field is required.")]) : _vm._e(), _vm._v(" "), (!_vm.$v.credentials.last_name.minLength) ? _c('span', {
    staticClass: "el-form-item__error"
  }, [_vm._v("Last Name must have at least " + _vm._s(_vm.$v.credentials.last_name.$params.minLength.min) + " letters.")]) : _vm._e()]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Location:"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Your location",
      "type": "text",
      "disabled": _vm.app.isLoading
    },
    on: {
      "input": function($event) {
        _vm.$v.credentials.location.$touch()
      }
    },
    model: {
      value: (_vm.credentials.location),
      callback: function($$v) {
        _vm.credentials.location = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "credentials.location"
    }
  }), _vm._v(" "), (_vm.$v.credentials.location.$error) ? _c('span', [(!_vm.$v.credentials.location.required) ? _c('span', {
    staticClass: "el-form-item__error"
  }, [_vm._v("Field is required.")]) : _vm._e()]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Email:"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Your email",
      "type": "email",
      "disabled": _vm.app.isLoading
    },
    on: {
      "input": function($event) {
        _vm.$v.credentials.email.$touch()
      }
    },
    model: {
      value: (_vm.credentials.email),
      callback: function($$v) {
        _vm.credentials.email = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "credentials.email"
    }
  }), _vm._v(" "), (_vm.$v.credentials.email.$error) ? _c('span', [(!_vm.$v.credentials.email.required) ? _c('span', {
    staticClass: "el-form-item__error"
  }, [_vm._v("Field is required.")]) : _vm._e(), _vm._v(" "), (!_vm.$v.credentials.email.email) ? _c('span', {
    staticClass: "el-form-item__error"
  }, [_vm._v("Must be a valid email.")]) : _vm._e()]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "VIN Number:"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Your first name",
      "type": "text",
      "disabled": _vm.app.isLoading
    },
    on: {
      "input": function($event) {
        _vm.$v.credentials.vin_chassis_no.$touch()
      }
    },
    model: {
      value: (_vm.credentials.vin_chassis_no),
      callback: function($$v) {
        _vm.credentials.vin_chassis_no = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "credentials.vin_chassis_no"
    }
  }), _vm._v(" "), (_vm.$v.credentials.vin_chassis_no.$error) ? _c('span', [(!_vm.$v.credentials.vin_chassis_no.required) ? _c('span', {
    staticClass: "el-form-item__error"
  }, [_vm._v("Field is required.")]) : _vm._e(), _vm._v(" "), (!_vm.$v.credentials.vin_chassis_no.minLength) ? _c('span', {
    staticClass: "el-form-item__error"
  }, [_vm._v("VIN Number must have at least " + _vm._s(_vm.$v.credentials.vin_chassis_no.$params.minLength.min) + " letters.")]) : _vm._e(), _vm._v(" "), (!_vm.$v.credentials.vin_chassis_no.alphaNum) ? _c('span', {
    staticClass: "el-form-item__error"
  }, [_vm._v("VIN Number can only container letters and numbers.")]) : _vm._e()]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Vehicle model:"
    }
  }, [_c('el-select', {
    attrs: {
      "disabled": _vm.app.isLoading
    },
    model: {
      value: (_vm.credentials.vehicle_model),
      callback: function($$v) {
        _vm.credentials.vehicle_model = $$v
      },
      expression: "credentials.vehicle_model"
    }
  }, _vm._l((_vm.options), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  })), _vm._v(" "), (_vm.$v.credentials.vehicle_model.$error) ? _c('span', [(!_vm.$v.credentials.vehicle_model.required) ? _c('span', {
    staticClass: "el-form-item__error"
  }, [_vm._v("Field is required.")]) : _vm._e()]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": 'Odometer Reading (' + _vm.credentials.units + '):'
    }
  }, [_c('el-input-number', {
    attrs: {
      "step": 1,
      "disabled": _vm.app.isLoading,
      "min": "0"
    },
    on: {
      "input": function($event) {
        _vm.$v.credentials.odometer_reading.$touch()
      }
    },
    model: {
      value: (_vm.credentials.odometer_reading),
      callback: function($$v) {
        _vm.credentials.odometer_reading = _vm._n($$v)
      },
      expression: "credentials.odometer_reading"
    }
  }), _vm._v(" "), (!_vm.$v.credentials.odometer_reading.required) ? _c('span', {
    staticClass: "el-form-item__error"
  }, [_vm._v("Field is required.")]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Currency:"
    }
  }, [_c('el-select', {
    attrs: {
      "disabled": _vm.app.isLoading
    },
    model: {
      value: (_vm.credentials.currency),
      callback: function($$v) {
        _vm.credentials.currency = $$v
      },
      expression: "credentials.currency"
    }
  }, _vm._l((_vm.app.currencySymbols), function(symbol, iso) {
    return _c('el-option', {
      key: iso,
      attrs: {
        "label": iso + ' (' + symbol + ')',
        "value": iso
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Prefered Units:"
    }
  }, [_c('el-radio-group', {
    attrs: {
      "disabled": _vm.app.isLoading
    },
    model: {
      value: (_vm.credentials.units),
      callback: function($$v) {
        _vm.credentials.units = $$v
      },
      expression: "credentials.units"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "km"
    }
  }, [_vm._v("Kilometers")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "miles"
    }
  }, [_vm._v("Miles")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Password:"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Password",
      "type": "password",
      "disabled": _vm.app.isLoading
    },
    on: {
      "input": function($event) {
        _vm.$v.credentials.password.$touch()
      }
    },
    model: {
      value: (_vm.credentials.password),
      callback: function($$v) {
        _vm.credentials.password = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "credentials.password"
    }
  }), _vm._v(" "), (_vm.$v.credentials.password.$error) ? _c('span', [(!_vm.$v.credentials.password.required) ? _c('span', {
    staticClass: "el-form-item__error"
  }, [_vm._v("Field is required.")]) : _vm._e(), _vm._v(" "), (!_vm.$v.credentials.password.minLength) ? _c('span', {
    staticClass: "el-form-item__error"
  }, [_vm._v("Email must have at least " + _vm._s(_vm.$v.credentials.password.$params.minLength.min) + " characters.")]) : _vm._e()]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Repeat Password:"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Password",
      "type": "password",
      "disabled": _vm.app.isLoading
    },
    on: {
      "input": function($event) {
        _vm.$v.credentials.repeatPassword.$touch()
      }
    },
    model: {
      value: (_vm.credentials.repeatPassword),
      callback: function($$v) {
        _vm.credentials.repeatPassword = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "credentials.repeatPassword"
    }
  }), _vm._v(" "), (_vm.$v.credentials.repeatPassword.$error) ? _c('span', [(!_vm.$v.credentials.repeatPassword.required) ? _c('span', {
    staticClass: "el-form-item__error"
  }, [_vm._v("Field is required.")]) : _vm._e(), _vm._v(" "), (!_vm.$v.credentials.repeatPassword.sameAsPassword) ? _c('span', {
    staticClass: "el-form-item__error"
  }, [_vm._v("Passwords must be identical.")]) : _vm._e()]) : _vm._e()], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', [_c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.$v.$invalid || _vm.app.isLoading,
      "loading": _vm.app.isLoading
    },
    on: {
      "click": function($event) {
        _vm.register()
      }
    }
  }, [_vm._v("\n\t\t\t\t\tRegister\n\t\t\t\t")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3de21fa8","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/auth/Register.vue
// module id = 628
// module chunks = 1